import { useEffect, useState } from 'react';
import { Typography } from '@banhala/ui-kit';
import { useInterval } from 'shared/src/hooks';

type CountdownProps = {
  deadline: number;
  onExpire: () => void;
};

const formatRemain = (seconds: number) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `남은 시간 ${m}:${String(s).padStart(2, '0')}`;
};

export const Countdown = ({ deadline, onExpire }: CountdownProps) => {
  const [now, setNow] = useState(() => Date.now());
  const secondsLeft = Math.max(0, Math.ceil((deadline - now) / 1000));
  const isExpired = secondsLeft === 0;

  useInterval(() => setNow(Date.now()), isExpired ? null : 1000);

  useEffect(() => {
    if (isExpired) {
      onExpire();
    }
  }, [isExpired, onExpire]);

  return (
    <Typography type={'body2'} color={'content_pink_primary'}>
      {formatRemain(secondsLeft)}
    </Typography>
  );
};
